export default __webpack_public_path__ + "static/media/Smoke_sensor.54124d26.svg";